<template>
	<BaseCmsPage v-slot="{page}" @load="onPageLoad">
		<AuthPageLayout>
			<h1 class="auth-main-title" v-html="page?.seo_h1"></h1>
			<BaseAuthChangePasswordForm v-slot="{fields, loading, submitting, apiErrors, onSubmit, status}">
				<template v-if="apiErrors?.length">
					<div class="global-error" v-for="apiError in apiErrors" :key="apiError">{{ labels.get(apiError?.error) }}</div>
				</template>
				<div v-if="status && status?.success" class="global-success">{{ labels.get(status?.data?.label_name) }}</div>

				<div v-if="!status?.success" class="form-animated-label auth-form auth-change-password-form" :class="{'submitting': submitting, 'loading': loading}" @submit="onSubmit">
					<template v-if="!fields?.length">
						<BaseThemeUiLoading />
					</template>
					<template v-else>
						<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel}">
							<p class="field" :class="['field-' + item.name, {'ffl-floated': floatingLabel}]">
								<BaseFormInput />
								<BaseCmsLabel tag="label" :for="item.name" :code="item.name" />
								<span class="error" v-show="errorMessage" v-html="errorMessage" />
							</p>
						</BaseFormField>
						<button class="btn btn-signup" type="submit" :disabled="loading">
							<UiLoader v-if="loading" class="dots" />
							<BaseCmsLabel v-else code="save" />
						</button>
					</template>
				</div>
			</BaseAuthChangePasswordForm>
		</AuthPageLayout>
	</BaseCmsPage>
</template>

<script setup>
	const labels = useLabels();
	const {mobileBreakpoint} = inject('rwd');

	//gtm
	const {gtmTrack} = useGtmBB();
	function onPageLoad(data) {
		if(!data) return;
		gtmTrack('virtualPageview', {
			url: data?.url || '',
			title: data?.title || '',
		});
	}
</script>

<style lang="less" scoped>
	.auth-change-password-form{
		max-width: 500px;
		@media (max-width: @m){max-width: none;}
	}
	.btn-signup{
		min-width: 200px;
		@media (max-width: @m){width: 100%;}
	}	
</style>
